<template>
  <CompanyRLSGroupListSkeleton>
    <b-list-group class="mt-4" flush>
      <b-list-group-item
        v-for="item in items"
        :key="`company-rls-group-list-item-${item}`"
        class="py-2 px-0 small"
      >
        {{ item }}
      </b-list-group-item>
    </b-list-group>
  </CompanyRLSGroupListSkeleton>
</template>

<script>
import { defineComponent, computed, inject } from '@vue/composition-api'

import CompanyRLSGroupListSkeleton from './CompanyRLSGroupListSkeleton.vue'

export default defineComponent({
  name: 'CompanyRLSGroupList',
  components: {
    CompanyRLSGroupListSkeleton
  },
  setup() {
    const { rlsGroup, rlsGroupItems, company } = inject('company-rls-group')

    const items = computed(() => {
      if (!!company.value) {
        return rlsGroupItems.value
          .filter((rlsGroupItem) => {
            return (
              company.value[`rls_${rlsGroup.value.toLowerCase()}_ids`] || []
            ).includes(rlsGroupItem.id)
          })
          .map(
            (rlsGroupItem) =>
              rlsGroupItem[rlsGroup.value] ||
              rlsGroupItem[rlsGroup.value.toLowerCase()]
          )
      } else {
        return []
      }
    })

    return {
      rlsGroupItems,

      items
    }
  }
})
</script>
